import { fetchMessages } from "./ChatActions";
import { getLanguages } from "./UserActions";
import { deploymentNeGD } from "../NewConstants/DeploymentConstants";

export const SESSION_ROW_BG = "color-mix(in srgb, var(--primary-dark) 10%, transparent)";

export function getUserToken() {
  const token = localStorage.getItem("token");
  return token;
}

export function setUserToken(token) {
  return localStorage.setItem("token", token);
}

export function setUserProfileData(profileData) {
  return localStorage.setItem("userProfileData", JSON.stringify(profileData));
}
export function getUserLocationState() {
  const data = JSON.parse(localStorage.getItem("userProfileData"));
  return data?.location?.state?.en;
}
export function getUserLocationDistrict() {
  const data = JSON.parse(localStorage.getItem("userProfileData"));
  return data?.location?.district?.en;
}

export async function getMessages(offset = null, fetchDirection = null) {
  const messages = await fetchMessages(getUserToken(), offset, fetchDirection);
  return messages;
}

export function getMessageBlock(messageObj) {
  return {
    bot: {
      text: messageObj["bot"] || null,
      suggested_questions: messageObj["suggested_questions"] || null,
      disclaimer: messageObj["disclaimer"] || null,
      sources: messageObj["sources"] || null,
      take_feedback: messageObj["take_feedback"] || null,
      feedback: messageObj["feedback"] || null,
      welcome: messageObj["welcome"] || null,
      error: messageObj["error"] || null,
    },
    user: {
      text: messageObj["user"]["query"] || null,
      welcome: messageObj["welcome"] || null,
      image: messageObj["image"] || null,
    },
  };
}

export function getBotMessageBlock(messageObj) {
  return {
    bot: {
      text: messageObj["bot"] || null,
      suggested_questions: messageObj["suggested_questions"] || null,
      disclaimer: messageObj["disclaimer"] || null,
      sources: messageObj["sources"] || null,
      take_feedback: messageObj["take_feedback"] || null,
      feedback: messageObj["feedback"] || null,
      welcome: messageObj["welcome"] || null,
      error: messageObj["error"] || null,
    },
  };
}

export function getUserMessageBlock(input, defaultFlag, image, selectedLanguage, sessionId = null) {
  const block = {
    user: {
      language: selectedLanguage,
      text: input,
      welcome: defaultFlag || null,
      image: image,
    },
  };
  if (sessionId) {
    block.session_id = sessionId;
  }
  return block;
}

export function getProcessedCustomPayload(
  inputText,
  audioArr,
  selectedLanguageCode,
  customQueryFlag,
  image = null,
  sessionFlags = {}
) {
  const { newSession = false, sessionId = null } =
    typeof sessionFlags === "boolean"
      ? { newSession: sessionFlags, sessionId: null }
      : sessionFlags;
  let payload = {
    values: [
      {
        value: inputText,
        type: "text",
      },
    ],
    audios: audioArr,
    lang: selectedLanguageCode,
    image: image,
    custom_query_flag: customQueryFlag,
    approach: getUserApproach(),
  };
  if (newSession) {
    payload.new_session = true;
  }
  if (sessionId) {
    payload.session_id = sessionId;
  }
  if (getUserKb() === "GHS") {
    if (inputText !== localStorage.getItem("selectedDocument")) {
      payload["documents_to_search"] = localStorage
        .getItem("selectedDocument")
        .split(",");
    } else {
      payload["documents_to_search"] = "";
    }
  }
  return payload;
}
export function setUserApproach(userApproach) {
  return localStorage.setItem("user_Approach", userApproach);
}

export function getUserApproach() {
  const userApproach = localStorage.getItem("user_Approach");
  return userApproach;
}
export const stopPlayingAudio = (audioRef) => {
  if (audioRef.current) {
    audioRef.current.pause();
  }
};

export const playAudio = (filePath, audioRef, onEnd) => {
  if (audioRef.current) {
    audioRef.current.pause();
  }
  const audio = new Audio(filePath);
  if (onEnd) audio.addEventListener("ended", onEnd);
  audioRef.current = audio;
  audio.play().catch((err) => console.error("Audio play error:", err));
};

export function saveSelectedDocument(selectedDocument) {
  return localStorage.setItem("selectedDocument", selectedDocument);
}

export function getConsentFlag() {
  const consentFlag = JSON.parse(localStorage.getItem("consent"));
  return consentFlag;
}
export function saveConsentFlag(consentFlag) {
  return localStorage.setItem("consent", consentFlag);
}

export function getOnboardingFlag() {
  const onboarding = JSON.parse(localStorage.getItem("onboarding"));
  return onboarding;
}

export function saveOnboardingFlag(onboardingFlag) {
  return localStorage.setItem("onboarding", onboardingFlag);
}

export function getMobileNumber() {
  const mobileNumber = localStorage.getItem("mobile_number");
  return mobileNumber;
}

export function saveMobileNumber(mobileNumber) {
  return localStorage.setItem("mobile_number", mobileNumber);
}

export function setUserType(userType) {
  return localStorage.setItem("user_type", userType);
}

export function getUserType() {
  const userType = localStorage.getItem("user_type");
  return userType;
}

export function setUserCadre(userCadre) {
  return localStorage.setItem("user_cadre", userCadre);
}

export function getUserCadre() {
  const userRole = localStorage.getItem("user_cadre");
  return userRole;
}
export function setAgents(agents) {
  return localStorage.setItem("agents", JSON.stringify(agents));
}
export function getAgents() {
  const agents = JSON.parse(localStorage.getItem("agents"));
  return agents;
}
export function setUserKb(userKb) {
  return localStorage.setItem("user_kb", userKb);
}

export function getUserKb() {
  const userKb = localStorage.getItem("user_kb");
  return userKb;
}

export function setDefaultLanguage(defaultLanguage) {
  return localStorage.setItem("defaultLanguage", defaultLanguage);
}

export function getDefaultLanguage() {
  const defaultLanguage = localStorage.getItem("defaultLanguage");
  return defaultLanguage;
}
export function setUserId(userId){
  return localStorage.setItem("user_id", userId);
}
export function getUserId(){
  const userId = localStorage.getItem("user_id");
  return userId;
}
export function setTooltip(tooltip) {
  return localStorage.setItem("tooltip", JSON.stringify(tooltip));
}
export function getTooltip() {
  const tooltip = JSON.parse(localStorage.getItem("tooltip"));
  return tooltip;
}

export function updateTooltipFlag(key, value) {
  const tooltip = getTooltip();
  tooltip[key] = value;
  localStorage.setItem("tooltip", JSON.stringify(tooltip));
}

export function getLanguageChangeFlag() {
  const languageChangeFlag = localStorage.getItem("language_change");
  return languageChangeFlag;
}
export function setLanguageChangeFlag(languageChangeFlag) {
  return localStorage.setItem("language_change", languageChangeFlag);
}

export function getParamToken() {
  const paramToken = localStorage.getItem("param_token");
  return paramToken;
}
export function setParamToken(paramToken) {
  return localStorage.setItem("param_token", paramToken);
}

export function removeParamToken() {
  return localStorage.removeItem("param_token");
}
export function getDeployment() {
  const deployment = localStorage.getItem("deployment");
  return deployment;
}
export function setDeployment(deployment) {
  return localStorage.setItem("deployment", deployment);
}
export function isIframeDeployment() {
  return getDeployment() === deploymentNeGD;
}
export function trackEvent(category, action, label = "") {
  const userType = getUserType();
  const userCadre = getUserCadre();
  const userLocationState = getUserLocationState();
  const userLocationDistrict = getUserLocationDistrict();
  const userId = getUserId();
  const userKb_userApproach = getUserKb() + " " + getUserApproach();
  if (window._paq) {
    window._paq.push(['setUserId', userId]);
    window._paq.push(['setCustomDimension', 1, userType]);
    window._paq.push(['setCustomDimension', 2, userCadre]);
    window._paq.push(['setCustomDimension', 3, userLocationState]);
    window._paq.push(['setCustomDimension', 4, userLocationDistrict]);
    window._paq.push(['setCustomDimension', 5, userKb_userApproach]);
    window._paq.push(["trackEvent", category, action, label]);
  }
}

// Tooltip onboarding utility
export function handleTooltipOnboarding(tooltip, setStepIndex, setStartTour) {
  if (!tooltip) return;
  if (tooltip.speaker === false) {
    setStepIndex(0);
    setStartTour(true);
  } else if (tooltip.typing === false) {
    setStepIndex(3);
    setStartTour(true);
  } else if (tooltip.mic === false) {
    setStepIndex(5);
    setStartTour(true);
  } else if (tooltip.chips === false) {
    setStepIndex(8);
    setStartTour(true);
  } else if (tooltip.star === false) {
    setStepIndex(13);
    setStartTour(true);
  } else if (tooltip.sources === false) {
    setStepIndex(14);
    setStartTour(true);
  }
}

export function CheckLanguageSupport() {
  async function fetchLanguages() {
    const res = await getLanguages(getUserCadre(), getUserKb());
    if (res?.status === 200 && res.data?.languages) {
      for (const lang of res.data.languages) {
        if (lang.value === getDefaultLanguage()) {
          return "chat";
        }
      }
      return "language-check";
    } else {
      localStorage.clear();
      sessionStorage.clear();
      return "/";
    }
  }
  return fetchLanguages();
}

// PWA Installation utilities
let deferredPrompt = null;

export function isPwaInstalled() {
  // Check if running in standalone mode (already installed as PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  // iOS Safari check
  if (window.navigator.standalone === true) {
    return true;
  }
  return false;
}

export function setDeferredPrompt(prompt) {
  deferredPrompt = prompt;
}

export function getDeferredPrompt() {
  return deferredPrompt;
}

export function clearDeferredPrompt() {
  deferredPrompt = null;
}

export async function triggerPwaInstall() {
  if (!deferredPrompt) {
    return { success: false, reason: 'no_prompt' };
  }
  
  // Store reference and clear immediately (prompt can only be used once)
  const prompt = deferredPrompt;
  deferredPrompt = null;
  
  try {
    // Show the install prompt (await the Promise)
    await prompt.prompt();
    
    // Wait for the user's response
    const { outcome } = await prompt.userChoice;
    
    if (outcome === 'accepted') {
      return { success: true, outcome: 'accepted' };
    } else {
      return { success: false, outcome: 'dismissed' };
    }
  } catch (error) {
    return { success: false, reason: 'error', error };
  }
}

export function getNewSessionFlag() {
  return localStorage.getItem("new_session") === "true";
}
export function setNewSessionFlag(newSessionFlag) {
  const on =
    newSessionFlag === true ||
    newSessionFlag === "true";
  return localStorage.setItem("new_session", on ? "true" : "false");
}